/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop, State, Listen, getAssetPath } from '@stencil/core';
import { Memoize, isEmpty, parseIfString } from '@springbokagency/stencil-base';

import type { HeaderData } from './header.types';
import checkWindowSize from '../../../utils/checkWindowSize';

@Component({
  tag: 'efb-header',
  styleUrl: 'header.scss',
  shadow: true,
})
export class EfbHeader {
  /**
   * State
   */

  @State() isMobile = checkWindowSize().isMobile;

  /**
   * Props
   */

  @Prop() data: HeaderData | string;

  @Memoize('data')
  get parsedData(): HeaderData {
    return parseIfString(this.data);
  }

  /**
   * Events
   */

  @Listen('resize', { target: 'window' })
  handleWindowResize() {
    this.isMobile = checkWindowSize().isMobile;
  }

  /**
   * Render
   */

  render() {
    return (
      <Host>
        <header class="header">
          <div class="header-content">
            {/* Logo */}
            {this.isMobile && (
              <img
                src={getAssetPath('/dist/assets/images/logos/ethias-logo-orange.png')}
                srcset={`${getAssetPath('/dist/assets/images/logos/ethias-logo-orange@2x.png')} 2x`}
                alt="Ethias logo"
                width="94"
                height="60"
              />
            )}
            {!this.isMobile && <efb-ethias-baseline orange noMargin />}

            {/* Lang switch */}
            {!isEmpty(this.parsedData?.langSwitch) && (
              <efb-lang-switch
                class="lang-switch"
                href={this.parsedData.langSwitch.href}
                text={this.parsedData.langSwitch.text}
              />
            )}
          </div>
        </header>
      </Host>
    );
  }
}
